/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   debounce: () => (/* binding */ debounce)
/* harmony export */ });
const debounce = (method, delay = 10) => {
  clearTimeout(method._tId);
  method._tId = setTimeout(() => {
    method();
  }, delay);
};


/***/ }),
/* 2 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   scrollLock: () => (/* binding */ scrollLock),
/* harmony export */   scrollToTop: () => (/* binding */ scrollToTop)
/* harmony export */ });
let locked = false;
const scrollLock = (lockScroll = false) => {
  if (locked === lockScroll) return;
  locked = lockScroll;
  if (locked) {
    document.body.classList.add("scroll-lock");
  } else {
    document.body.classList.remove("scroll-lock");
  }
};
const scrollToTop = () => {
  window.scrollTo({ top: 0 });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (scrollLock);


/***/ }),
/* 3 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addEvents: () => (/* binding */ addEvents),
/* harmony export */   closeDialog: () => (/* binding */ closeDialog),
/* harmony export */   getActiveDialog: () => (/* binding */ getActiveDialog),
/* harmony export */   openDialog: () => (/* binding */ openDialog)
/* harmony export */ });
/* harmony import */ var _scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

window.activeDialog = false;
let init = false;
const getActiveDialog = () => window.activeDialog || document.querySelector(".nav-active main-header");
const closeDialog = () => {
  const activeDialog = getActiveDialog();
  if (!activeDialog) return;
  window.activeDialog = false;
  activeDialog.close();
  (0,_scroll__WEBPACK_IMPORTED_MODULE_0__.scrollLock)(false);
};
const addEvents = () => {
  if (init) return;
  init = true;
  document.addEventListener("keydown", (event) => {
    const activeDialog = getActiveDialog();
    if (!activeDialog) return;
    if (event.key === "Escape") {
      event.preventDefault();
      closeDialog();
    }
    if (event.key === "Tab" || event.key === "Shift") {
      activeDialog.catchFocus(event);
    }
  });
  document.addEventListener("click", (event) => {
    const close = event.target.closest("[data-dialog-close]") || event.target.closest("[data-js-close]");
    const open = event.target.closest("[data-dialog-open]");
    if (!open && !close) return;
    event.preventDefault();
    if (close) closeDialog();
    if (open) {
      const { dialogOpen } = open.dataset;
      const toOpen = document.getElementById(dialogOpen);
      if (!toOpen) return;
      toOpen.open(open);
    }
  });
};
const openDialog = ({ dialog }) => {
  if (!dialog) return;
  closeDialog();
  if (!dialog.allowScroll) (0,_scroll__WEBPACK_IMPORTED_MODULE_0__.scrollLock)(true);
  const scroller = dialog.getElementsByClassName("dialog")[0];
  if (scroller) scroller.scrollTo({ top: 0 });
  dialog.style.zIndex = 1e3;
  window.activeDialog = dialog;
};


/***/ }),
/* 4 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   toggleVisibility: () => (/* binding */ toggleVisibility)
/* harmony export */ });
const hide = (el) => {
  el.classList.remove("is-visible");
  el.setAttribute("hidden", true);
};
const show = (el) => {
  el.removeAttribute("hidden");
  const reflow = el.offsetHeight;
  el.classList.add("is-visible");
};
const toggleVisibility = (el, showIt = false) => {
  if (!el) return;
  if (showIt) show(el);
  else hide(el);
};


/***/ }),
/* 5 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   serializeForm: () => (/* binding */ serializeForm)
/* harmony export */ });
const serializeForm = (form) => {
  const arr = [];
  Array.prototype.slice.call(form.elements).forEach((field) => {
    if (!field.name || field.disabled || ["file", "reset", "submit", "button"].indexOf(field.type) > -1) return;
    if (field.type === "select-multiple") {
      Array.prototype.slice.call(field.options).forEach((option) => {
        if (!option.selected) return;
        arr.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(option.value)}`);
      });
      return;
    }
    if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked) return;
    arr.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
  });
  return arr.join("&");
};


/***/ }),
/* 6 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getProduct: () => (/* binding */ getProduct)
/* harmony export */ });
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
window.products = window.products || {};
const getProduct = (handle) => __async(void 0, null, function* () {
  if (!handle) throw new Error("Handle required");
  window.products[handle] = window.products[handle] || (yield fetch(`/products/${handle}?view=json`).then((res) => res.json()));
  return window.products[handle];
});


/***/ }),
/* 7 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
const _formatWithDelimiters = (number, precision, thousands, decimal) => {
  const thous = thousands || ",";
  const dec = decimal || ".";
  if (isNaN(number) || number === null) return 0;
  const num = (number / 100).toFixed(precision);
  const parts = num.split(".");
  const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thous}`);
  const centsAmount = parts[1] ? dec + parts[1] : "";
  return dollarsAmount + centsAmount;
};
const formatMoney = (centsI, format) => {
  const cents = typeof centsI === "string" ? centsI.replace(".", "") : centsI;
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.shopSettings.moneyFormat;
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = _formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = _formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = _formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = _formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = _formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      value = _formatWithDelimiters(cents, 2, "'");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};


/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _api_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _api_scroll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _api_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var _api_visibility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _api_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var _api_product__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6);
/* harmony import */ var _api_money__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};







window.cart = window.cart || {};
const focusableSelectors = [
  'a[href]:not([tabindex^="-"])',
  'area[href]:not([tabindex^="-"])',
  'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
  'input[type="radio"]:not([disabled]):not([tabindex^="-"])',
  'select:not([disabled]):not([tabindex^="-"])',
  'textarea:not([disabled]):not([tabindex^="-"])',
  'button:not([disabled]):not([tabindex^="-"])',
  'iframe:not([tabindex^="-"])',
  'audio[controls]:not([tabindex^="-"])',
  'video[controls]:not([tabindex^="-"])',
  '[contenteditable]:not([tabindex^="-"])',
  '[tabindex]:not([tabindex^="-"])'
];
if (!window.customElements.get("dialog-box")) {
  class Dialog extends HTMLElement {
    constructor() {
      super();
      this.toggleElements = Array.from(this.querySelectorAll("[data-name]"));
      this.triggerElements = Array.from(document.querySelectorAll(`[data-dialog-open="${this.id}"][data-toggles]`));
      this.focusableChildren = Array.from(this.querySelectorAll(focusableSelectors));
      this.recs = this.querySelector("#cart-recommendations-sidebar");
      this.name = this.id;
      this.isOpen = false;
      this.isUnique = this.getAttribute("unique") === "true";
      this.allowScroll = this.getAttribute("allowscroll") === "true";
      this.isEmail = this.name === "email";
      this.close = this.close.bind(this);
      this.hide = this.close;
      this.swapBody = this.querySelector(".js-dialog-body");
      this.open = this.open.bind(this);
      this.show = this.open;
      this.catchFocus = this.catchFocus.bind(this);
    }
    setClosed(closing = false, target) {
      (0,_api_visibility__WEBPACK_IMPORTED_MODULE_3__.toggleVisibility)(this, !closing);
      const reset = this.querySelector("[data-reset-on-close]");
      if (reset) reset.setAttribute("closed", closing);
      window.dialogEl = this;
      if (closing && this.trigger) this.trigger.focus();
      this.trigger = target ? target.closest(focusableSelectors) : false;
    }
    /* shift key goes back; tab key goes forward */
    catchFocus(event) {
      let focusedIndex = this.focusableChildren.indexOf(document.activeElement);
      const lastIndex = this.focusableChildren.length - 1;
      if (event.shiftKey && focusedIndex <= 0) {
        event.preventDefault();
        this.focusableChildren[lastIndex].focus();
        focusedIndex = lastIndex;
      } else if (!event.shiftKey && (focusedIndex === lastIndex || focusedIndex < 0)) {
        event.preventDefault();
        this.focusableChildren[0].focus();
        focusedIndex = 0;
      }
    }
    /* setting an active triggerElement (ie. nav menu): */
    setActive(index) {
      this.toggleIndex = index;
      const active = document.querySelector(`.is-active[data-dialog-open=${this.id}]`);
      if (active) active.classList.remove("is-active");
      if (typeof index === "undefined") return;
      const trigger = this.triggerElements[index];
      if (trigger) {
        trigger.classList.add("is-active");
        this.trigger = trigger;
      }
    }
    toggleElement(triggerElement) {
      if (!triggerElement) return;
      const { toggles } = triggerElement.dataset;
      if (!toggles) return;
      for (let i = 0; i < this.toggleElements.length; i += 1) {
        const toggle = this.toggleElements[i];
        const isVisible = toggle.dataset.name === toggles;
        (0,_api_visibility__WEBPACK_IMPORTED_MODULE_3__.toggleVisibility)(toggle, isVisible);
        if (isVisible) {
          this.focusableChildren = Array.from(toggle.querySelectorAll(focusableSelectors));
          this.setActive(i);
          this.setFocus();
        }
      }
    }
    checkIfOpen() {
      return this.isOpen;
    }
    // focus on first focusable element:
    setFocus(focus = "no") {
      const focusFirst = this.querySelector(focus) || this.focusableChildren[0];
      focusFirst.focus();
    }
    swapHTML(target) {
      if (!target) return;
      const { html } = target.dataset;
      if (html) this.swapBody.innerHTML = html;
    }
    /* opens : */
    open(target) {
      if (this.isOpen) return;
      this.setClosed(false, target);
      this.swapHTML(target);
      this.setFocus(target ? target.dataset.focus : false);
      this.toggleElement(target);
      (0,_api_dialog__WEBPACK_IMPORTED_MODULE_2__.openDialog)({ dialog: this });
      this.isOpen = true;
      if (this.recs) {
        setTimeout(() => {
          var _a;
          (_a = this.recs.querySelector("css-slider")) == null ? void 0 : _a.resetSlider();
        }, 10);
      }
    }
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      (0,_api_dialog__WEBPACK_IMPORTED_MODULE_2__.closeDialog)(this.name);
      this.setClosed(true);
      this.setActive();
    }
    addTriggerEvents() {
      if (!this.triggerElements.length) return;
      for (let i = 0; i < this.triggerElements.length; i += 1) {
        const trigger = this.triggerElements[i];
        trigger.addEventListener("mouseenter", () => {
          if (!this.isOpen) return;
          this.toggleElement(trigger);
        });
      }
      document.addEventListener("keydown", ({ code }) => {
        if (!this.isOpen || typeof this.toggleIndex === "undefined") return;
        if (code !== "ArrowRight" && code !== "ArrowLeft") return;
        const newIndex = code === "ArrowRight" ? this.toggleIndex += 1 : this.toggleIndex -= 1;
        const activeTrigger = this.triggerElements[newIndex];
        this.toggleElement(activeTrigger);
      });
    }
    connectedCallback() {
      (0,_api_dialog__WEBPACK_IMPORTED_MODULE_2__.addEvents)();
      this.addTriggerEvents();
    }
  }
  window.customElements.define("dialog-box", Dialog);
}
if (typeof MainHeader !== "function") {
  class MainHeader2 extends HTMLElement {
    constructor() {
      super();
      this.menu = this.getElementsByClassName("menu")[0];
      this.menus = Array.from(this.querySelectorAll("[data-menu-name]"));
      this.panelButtons = Array.from(this.querySelectorAll("[data-menu]"));
      this.navButtons = this.panelButtons.filter((btn) => btn.classList.contains("nav-button"));
      this.focusableChildren = Array.from(this.querySelectorAll(focusableSelectors));
      this.panelName = false;
      this.active = false;
      this.handleNavClick = this.handleNavClick.bind(this);
      this.close = this.close.bind(this);
      this.open = this.open.bind(this);
      this.toggleAccordion = this.toggleAccordion.bind(this);
      this.togglePanel = this.togglePanel.bind(this);
      this.closeIfDesktop = this.closeIfDesktop.bind(this);
      this.catchFocus = this.catchFocus.bind(this);
    }
    catchFocus(event) {
      let focusedIndex = this.focusableChildren.indexOf(document.activeElement);
      const lastIndex = this.focusableChildren.length - 1;
      if (event.shiftKey && focusedIndex <= 0) {
        event.preventDefault();
        this.focusableChildren[lastIndex].focus();
        focusedIndex = lastIndex;
      } else if (!event.shiftKey && (focusedIndex === lastIndex || focusedIndex < 0)) {
        event.preventDefault();
        this.focusableChildren[0].focus();
        focusedIndex = 0;
      }
    }
    close() {
      if (!this.active) return;
      (0,_api_scroll__WEBPACK_IMPORTED_MODULE_1__.scrollLock)(false);
      document.body.classList.remove("nav-active");
      this.togglePanel();
      this.active = false;
      if (this.trigger) this.trigger.focus();
    }
    open(panelName, target) {
      (0,_api_scroll__WEBPACK_IMPORTED_MODULE_1__.scrollLock)(true);
      document.body.classList.add("nav-active");
      this.togglePanel(panelName || this.menus[0].dataset.menuName);
      this.trigger = target ? target.closest(focusableSelectors) : false;
    }
    toggleAccordion(toggle) {
      const accordion = toggle.closest(".nav-col");
      if (accordion.classList.contains("is-open")) accordion.classList.remove("is-open");
      else accordion.classList.add("is-open");
    }
    setSize(curr) {
      let { size } = curr.dataset;
      size = parseInt(size);
      Array.from(curr.querySelectorAll(".nav-col")).map((el) => {
        const height = el.firstElementChild.clientHeight;
        if (height > size) size = height;
        return;
      });
      this.style.setProperty("--menu-height", `${size + 36}px`);
    }
    togglePanel(panelName = false) {
      for (let i = 0; i < this.menus.length; i += 1) {
        const curr = this.menus[i];
        const { menuName } = curr.dataset;
        if (panelName && menuName === panelName) {
          this.menu.classList.add(`active-${panelName}`);
          this.active = curr;
          curr.classList.add("is-visible");
          this.setSize(curr);
          this.focusableChildren = Array.from(this.active.querySelectorAll(focusableSelectors));
        } else if (curr.classList.contains("is-visible")) {
          curr.classList.remove("is-visible");
          this.menu.classList.remove(`active-${menuName}`);
        }
      }
      this.panelButtons.map((button) => {
        const isActive = panelName && button.dataset.menu === panelName;
        return isActive ? button.classList.add("is-active") : button.classList.remove("is-active");
      });
    }
    handleNavClick({ target }) {
      const button = target.closest("[data-menu]");
      if (button) {
        const { menu } = button.dataset;
        return this.active && (!menu || this.active.dataset.menuName === menu) ? this.close() : this.open(menu, target);
      }
      const search = target.closest("[data-search]");
      if (search) {
        const menu = "search";
        return this.active && this.active.dataset.menuName === menu ? this.close() : this.open(menu, target);
      }
      const close = target.closest("[data-nav-close]");
      if (close) return this.close();
      const toggle = target.closest("[data-toggle-nav]");
      if (toggle) return this.toggleAccordion(toggle);
      const insideNav = target.closest(".menu");
      if (!insideNav && this.active) return this.close();
    }
    isDesktop() {
      return window.innerWidth >= 1200;
    }
    closeIfDesktop() {
      if (window.scrollY > 500) document.body.classList.add("show-top");
      else document.body.classList.remove("show-top");
      if (this.isDesktop()) this.close();
    }
    addEvents() {
      var _a, _b;
      document.addEventListener("click", this.handleNavClick);
      document.addEventListener("scroll", () => {
        (0,_api_debounce__WEBPACK_IMPORTED_MODULE_0__.debounce)(this.closeIfDesktop, 10);
      }, { passive: true });
      this.navButtons.map((btn) => btn.addEventListener("mouseenter", () => {
        const { menu } = btn.dataset;
        if (this.opening === menu || !this.isDesktop()) return;
        if (this.active) return this.open(menu, btn);
        clearTimeout(this.menuDelayOpen);
        this.opening = menu;
        this.menuDelayOpen = setTimeout(() => {
          this.open(menu, btn);
          this.opening = false;
        }, 100);
      }));
      (_a = this.menu) == null ? void 0 : _a.addEventListener("mouseleave", () => {
        clearTimeout(this.menuDelayOpen);
        this.menuDelayClose = setTimeout(() => {
          this.closeIfDesktop();
        }, 300);
      });
      (_b = this.menu) == null ? void 0 : _b.addEventListener("mouseenter", () => {
        clearTimeout(this.menuDelayClose);
      });
    }
    connectedCallback() {
      this.addEvents();
    }
  }
  if (typeof customElements.get("main-header") === "undefined") {
    customElements.define("main-header", MainHeader2);
  }
}
if (!window.customElements.get("video-player")) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.onIntersect = this.onIntersect.bind(this);
      this.offIntersect = this.offIntersect.bind(this);
    }
    buildError() {
      const span = document.createElement("span");
      span.textContent = "missing required attributes (src)";
      return span;
    }
    buildVideo({ src, hasControls = false }) {
      if (!src) return this.buildError();
      const video = document.createElement("video");
      video.type = "video/mp4";
      video.src = src;
      video.poster = this.dataset.poster || "";
      video.disablePictureInPicture = true;
      if (hasControls) {
        video.controls = true;
        video.controlslist = "nodownload";
      } else {
        video.loop = true;
        video.autoplay = true;
        video.muted = true;
        video.defaultMuted = true;
        video.controls = false;
        video.setAttribute("playsinline", "");
      }
      return video;
    }
    getVideo() {
      const src = this.attributes.src ? this.attributes.src.value : false;
      const hasControls = this.attributes.controls ? this.attributes.controls.value === "true" : false;
      const video = this.buildVideo({ src, hasControls });
      this.video = video;
      this.appendChild(video);
    }
    onIntersect() {
      if (this.video) {
        if (this.video.autoplay) this.video.play();
      } else {
        this.getVideo();
      }
    }
    offIntersect() {
      if (this.video) this.video.pause();
    }
    connectedCallback() {
      const options = {
        root: null,
        rootMargin: "0px"
        // TODO: header height?
      };
      const observer = new IntersectionObserver((entries) => {
        for (let i = 0; i < entries.length; i += 1) {
          const entry = entries[i];
          if (entry.isIntersecting || entry.isVisible) this.onIntersect();
          else this.offIntersect();
        }
      }, options);
      observer.observe(this);
    }
  }
  window.customElements.define("video-player", VideoPlayer);
}
if (!window.customElements.get("cart-form")) {
  class CartForm extends HTMLElement {
    /* shows/hides/updates inline cart */
    constructor() {
      super();
      this.cart = document.getElementById("cart-sidebar");
      window.cart.show = this.show.bind(this);
      window.cart.hide = this.hide.bind(this);
      window.cart.update = this.update.bind(this);
      this.setLoading = this.setLoading.bind(this);
    }
    setLoading(isLoading = false) {
      if (isLoading) this.classList.add("is-loading");
      else this.classList.remove("is-loading");
    }
    getCart() {
      this.setLoading(true);
      const url = `${window.location.pathname}?section_id=cart-body`;
      return fetch(url, {
        method: "GET",
        headers: {
          "Cache-Control": "no-store",
          "Vary": "*"
        }
      }).then((res) => res.text()).then((html) => {
        var _a;
        this.innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector("cart-form").innerHTML;
        this.updateByKey({
          item_count: (_a = this.querySelector(".js-item-count")) == null ? void 0 : _a.textContent
        });
        this.setLoading(false);
        return Promise.resolve();
      });
    }
    updateByKey(cart) {
      const cartUpdates = Array.from(document.querySelectorAll("[data-cart-key]"));
      cartUpdates.map((el) => {
        const key = el.dataset.cartKey;
        const attr = el.dataset.attr || "textContent";
        const format = el.dataset.format;
        let newVal = cart[key];
        if (newVal === void 0) return;
        if (format === "money") {
          newVal = (0,_api_money__WEBPACK_IMPORTED_MODULE_6__.formatMoney)(newVal);
        }
        el[attr] = newVal;
      });
    }
    update({ updates }, key = "") {
      this.setLoading(true);
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      }).then((res) => res.json()).then((res) => {
        if (res.item_count === 0) {
          this.getCart();
          return;
        }
        this.updateByKey(res);
        if (key) {
          const priceEl = this.querySelector(`[data-line-price="${key}"]`);
          const newVar = res.items.find((variant) => variant.key === key);
          if (!priceEl || !newVar) return;
          priceEl.textContent = (0,_api_money__WEBPACK_IMPORTED_MODULE_6__.formatMoney)(newVar.line_price);
        }
        this.setLoading(false);
      });
    }
    hide() {
      this.cart.hide();
    }
    show() {
      this.getCart().then(() => {
        this.cart.show();
      });
    }
    addEvents() {
      this.addEventListener("click", (e) => {
        const remove = e.target.closest(".js-remove");
        if (!remove) return;
        e.preventDefault();
        const updates = {};
        updates[remove.dataset.key] = 0;
        this.update({ updates });
        const tile = remove.closest(".tile-cart");
        if (tile) tile.hidden = true;
      });
    }
    connectedCallback() {
      this.addEvents();
    }
  }
  window.customElements.define("cart-form", CartForm);
}
if (typeof ProductQuantity !== "function") {
  class ProductQuantity2 extends HTMLElement {
    constructor() {
      super();
      this.key = this.dataset.key;
      this.qty = this.querySelector(".qty");
      this.qtyBtns = Array.from(this.getElementsByClassName("qty-button"));
      this.min = 0;
      this.max = 999;
      this.currentQty = 0;
    }
    updateButtons() {
      this.currentQty = parseInt(this.qty.value);
      if (this.currentQty - 1 < this.min) this.qtyBtns[0].classList.add("disabled");
      if (this.currentQty + 1 > this.max) this.qtyBtns[1].classList.add("disabled");
    }
    changeQty(e, btn) {
      if (!btn || btn.classList.contains("disabled")) return;
      e.preventDefault();
      this.qty.value = btn.classList.contains("qty-minus") ? this.currentQty - 1 : this.currentQty + 1;
      this.updateButtons();
      const updates = {};
      updates[this.key] = this.currentQty;
      window.cart.update({ updates }, this.key);
    }
    addEvents() {
      this.addEventListener("click", (e) => {
        this.changeQty(e, e.target.closest(".qty-button"));
      });
    }
    connectedCallback() {
      if (!this.qty || this.qtyBtns.length < 2) return;
      this.addEvents();
      this.updateButtons();
    }
  }
  if (typeof customElements.get("product-quantity") === "undefined") {
    customElements.define("product-quantity", ProductQuantity2);
  }
}
if (!window.customElements.get("buy-box")) {
  class ProdAdd extends HTMLElement {
    /* adds current variant to cart */
    constructor() {
      super();
      this.form = this.getElementsByTagName("form")[0];
      this.bis = this.getElementsByClassName("bis")[0];
      this.submit = this.querySelector('button[type="submit"] .btn-text');
      this.available = false;
      this.btnText = {
        oos: "Out of Stock",
        atc: "Add To Cart"
      };
      this.setBtn = this.setBtn.bind(this);
    }
    setBtn(isAvailable = false) {
      this.available = isAvailable;
      if (this.bis) {
        this.bis.hidden = isAvailable;
        this.submit.closest(".flex-row").hidden = !isAvailable;
      }
      if (this.available) {
        this.submit.parentElement.classList.remove("is-disabled");
        this.submit.textContent = this.btnText.atc;
      } else {
        this.submit.parentElement.classList.add("is-disabled");
        this.submit.textContent = this.btnText.oos;
      }
    }
    addCart() {
      if (!this.available) return;
      const body = (0,_api_form__WEBPACK_IMPORTED_MODULE_4__.serializeForm)(this.form);
      this.submit.classList.add("is-loading");
      fetch("/cart/add.js", {
        body,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest"
        },
        method: "POST"
      }).then((res) => res.json()).then((res) => {
        console.log("status", res);
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.submit.classList.remove("is-loading");
        window.cart.show();
      });
    }
    addEvents() {
      this.addEventListener("submit", (e) => {
        e.preventDefault();
        this.addCart();
      });
    }
    connectedCallback() {
      this.addEvents();
    }
  }
  window.customElements.define("buy-box", ProdAdd);
}
if (!window.customElements.get("prod-vars")) {
  class ProdVars extends HTMLElement {
    constructor() {
      super();
      this.handle = this.dataset.handle;
      this.setUrl = this.dataset.setUrl === "true";
      this.id = parseInt(this.dataset.id);
      this.currentVariant = {};
      this.options = [];
      this.prodAdd = this.closest("buy-box");
      this.scope = this.closest(".js-var-scope") || this.prodAdd;
      this.optionValues = [
        Array.from(this.querySelectorAll('input[name="0"]')),
        Array.from(this.querySelectorAll('input[name="1"]')),
        Array.from(this.querySelectorAll('input[name="2"]'))
      ];
      this.varData = Array.from(this.scope.querySelectorAll("[data-var-key]"));
    }
    updateURL() {
      if (!this.setUrl) return;
      const { search } = window.location;
      const view = search.indexOf("view") > -1 ? `&view=${search.split("view=")[1].split("&")[0]}` : "";
      window.history.replaceState({}, "", `${this.handle}?variant=${this.currentVariant.id}${view}`);
    }
    findVar(options, checkIfAvail = false) {
      const opts = options || this.options;
      const foundVar = this.variants.find((variant) => (!checkIfAvail || variant.available) && variant.options.every((option, index) => opts[index] === option));
      return foundVar;
    }
    setUnavailableOptions(indexChanged) {
      for (let i = 0; i < 3; i += 1) {
        if (i === indexChanged) continue;
        const optionList = this.optionValues[i];
        const options = this.options.slice();
        optionList.map((input) => {
          options[i] = input.value;
          const varAvailable = this.findVar(options, true);
          if (varAvailable) input.parentElement.classList.remove("is-unavailable");
          else input.parentElement.classList.add("is-unavailable");
        });
      }
    }
    updateHTML() {
      this.varData.map((el) => {
        const dataKey = el.dataset.varKey;
        const dataAttr = el.dataset.attr || "textContent";
        const val = this.currentVariant[dataKey];
        if (dataAttr.indexOf("class") > -1) {
          const toggleClass = dataAttr.split("_");
          if (val) el.classList.add(toggleClass);
          else el.classList.remove(toggleClass);
          return;
        }
        el[dataAttr] = val;
      });
    }
    setVar(currentVariant) {
      this.currentVariant = currentVariant;
      if (this.prodAdd) this.prodAdd.setBtn(this.product.available && this.currentVariant && this.currentVariant.available);
      this.updateHTML();
      this.updateURL();
    }
    handleChange(input) {
      const optionIndex = parseInt(input.name);
      const value = input.value;
      this.options[optionIndex] = value;
      this.setVar(this.findVar());
      this.setUnavailableOptions(optionIndex);
    }
    addEvents() {
      this.addEventListener("click", (e) => {
        const input = e.target.closest("input");
        if (!input) return;
        this.handleChange(input);
      });
    }
    connectedCallback() {
      return __async(this, null, function* () {
        this.product = yield (0,_api_product__WEBPACK_IMPORTED_MODULE_5__.getProduct)(this.handle);
        this.variants = this.product.variants;
        const newVar = this.variants.find((variant) => `${variant.id}` === `${this.id}`) || this.variants.find((variant) => variant.available) || this.variants[0];
        this.options = newVar.options.slice();
        this.setVar(newVar);
        this.setUnavailableOptions(3);
        this.addEvents();
      });
    }
  }
  window.customElements.define("prod-vars", ProdVars);
}

})();

/******/ })()
;